// extracted by mini-css-extract-plugin
export var blue = "_z-f";
export var brand = "_z-b";
export var darkGrey = "_z-e";
export var disabled = "_z-4";
export var disabledSubtle = "_z-5";
export var error = "_z-6";
export var green = "_z-g";
export var grey = "_z-d";
export var icon = "_z-0";
export var inherit = "_z-a";
export var lightGrey = "_z-c";
export var orange = "_z-i";
export var pink = "_z-k";
export var primary = "_z-1";
export var purple = "_z-l";
export var red = "_z-j";
export var secondary = "_z-2";
export var success = "_z-9";
export var tertiary = "_z-3";
export var warning = "_z-7";
export var warningSecondary = "_z-8";
export var white = "_z-m";
export var yellow = "_z-h";